var $5290ee6fe233ce19$exports = {};
$5290ee6fe233ce19$exports = {
    "endTime": `Kon\u{10D}ni \u{10D}as`,
    "startTime": `Za\u{10D}etni \u{10D}as`,
    "time": `\u{10C}as`
};


export {$5290ee6fe233ce19$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
